/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Team_Invite_Sent_ToastInputs */

const en_team_invite_sent_toast = /** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitation sent to ${i?.email}`)
};

const es_team_invite_sent_toast = /** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitación enviada a ${i?.email}`)
};

const fr_team_invite_sent_toast = /** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitation envoyée à ${i?.email}`)
};

const de_team_invite_sent_toast = /** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Einladung an ${i?.email} gesendet`)
};

const id_team_invite_sent_toast = /** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Undangan dikirim ke ${i?.email}`)
};

/** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */
const ja_team_invite_sent_toast = en_team_invite_sent_toast;

/** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */
const zh_team_invite_sent_toast = en_team_invite_sent_toast;

/** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */
const ar_team_invite_sent_toast = en_team_invite_sent_toast;

/** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */
const it_team_invite_sent_toast = en_team_invite_sent_toast;

/** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */
const ru_team_invite_sent_toast = en_team_invite_sent_toast;

/** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */
const pt_team_invite_sent_toast = en_team_invite_sent_toast;

/** @type {(inputs: Team_Invite_Sent_ToastInputs) => LocalizedString} */
const ko_team_invite_sent_toast = en_team_invite_sent_toast;

/**
* | output |
* | --- |
* | "Invitation sent to {email}" |
*
* @param {Team_Invite_Sent_ToastInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_invite_sent_toast = /** @type {((inputs: Team_Invite_Sent_ToastInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Invite_Sent_ToastInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_invite_sent_toast(inputs)
	if (locale === "es") return es_team_invite_sent_toast(inputs)
	if (locale === "fr") return fr_team_invite_sent_toast(inputs)
	if (locale === "de") return de_team_invite_sent_toast(inputs)
	if (locale === "ja") return ja_team_invite_sent_toast(inputs)
	if (locale === "zh") return zh_team_invite_sent_toast(inputs)
	if (locale === "ar") return ar_team_invite_sent_toast(inputs)
	if (locale === "id") return id_team_invite_sent_toast(inputs)
	if (locale === "it") return it_team_invite_sent_toast(inputs)
	if (locale === "ru") return ru_team_invite_sent_toast(inputs)
	if (locale === "pt") return pt_team_invite_sent_toast(inputs)
	return ko_team_invite_sent_toast(inputs)
});